var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-width"},[_c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"modals":_vm.modals,"methods":_vm.methods,"footer":_vm.footer,"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }